import { isPlatformConsoleUser } from 'classes/helpers/platform-console.helper';
import { useAuthStore } from 'stores/use-auth-store';

export const useIsPlatformConsoleUser = (): boolean => {
  const current = useAuthStore((s) => s.current);

  return isPlatformConsoleUser(current);
};
